import { usePermissionContext } from '@openx/utils/permission/context/PermissionContext';
import { useDealContext } from '../../utils/context/DealContext';

export function useOnBehalfOfAccountId(): string {
  const { session } = usePermissionContext();

  const { onBehalfOrganization } = useDealContext();

  const onBehalfOfAccountId = onBehalfOrganization
    ? onBehalfOrganization.exchange_account_network?.uid
    : session?.account.uid;

  return onBehalfOfAccountId as string;
}
